import React from "react";
import { useHistory, useParams } from "react-router-dom";
import styles from "./BasicButtons.module.css";
import tempProfileImg from "./../graphics/elements/profile_photo.svg";

import Back from "./../graphics/icons/back.svg";
import Logout from "./../graphics/icons/logout.svg";



function BasicButtons(props) {
  const { user, refreshStates } = props;

  const { leagueId } = useParams();
  const history = useHistory();

  const profileImg = user?.player?.profile_pic || tempProfileImg;

  const handleBack = () => {
    history.goBack();
  };


  const handleClickProfile = async () => {
    const userLeagueId = leagueId;
    const url = `/leagues/${userLeagueId}/profile`;
    history.push(url);
  };


  return (
    <div className={styles.basicButtons}>
      {user &&
        (user.is_leagues_manager ? (
          <div onClick={refreshStates} className={styles.logoutBtn}>
            <img src={Logout} alt="התנתקות" />
          </div>
        ) : (
          <img
            className={styles.profilePic}
            src={profileImg}
            alt="תמונת פרופיל שחקן"
            onClick={handleClickProfile}
          />
        ))}

      <div onClick={handleBack} className={styles.backBtn}>
        <img src={Back} alt="חזור" />
      </div>
      {}
    </div>
  );
}

export default BasicButtons;
